import React from "react";
import Container from "react-bootstrap/Container";
import styled from "styled-components";
import ReactTooltip from "react-tooltip";

import image17 from "../images/image17.svg";

import image13 from "../images/image13.png";


import image1 from "../images/image1.svg";
import image2 from "../images/image2.svg";
import image3 from "../images/image3.svg";
import image4 from "../images/image4.svg";
import image6 from "../images/image6.svg";
import image7 from "../images/image7.svg";
import image9 from "../images/image9.svg";

const StyledContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  flex: 0 0 auto;
  height: 60%;
  left: 55%;
  top: 40%;
  width: 1600px;
  position: absolute;
  margin: 0;
  z-index: 10;
  @media screen and (max-width: 425px) {
    top: 30%;
    left: 450px;
    height: 70%;
  }
  @media screen and (max-width: 330px) {
    top: 30%;
    left: 450px;
    height: 70%;
    width: 1200px;
  }
`;

const IconImage = styled.img`
  flex: 0 0 auto;
  left: ${props => (props.left ? props.left : 0)};
  position: relative;
  z-index: ${props => props.zIndex};
  height: 100%;
  :hover {
    cursor: pointer;
    height: 110%;
    top: -10%;
    z-index: 99;
  }
`;

const StyledTag = styled.a`
  display: inline-block;
  margin: 0;
  position: relative;
  z-index: ${props => props.zIndex};
  width: 15%;
`;

const imageClick = (url) => {
  console.log('should be clicking')
  window.open(url, '_blank');
};

const ImageContainer = ({ refs }) => {
  return (
    
    <StyledContainer ref={refs} fluid>
      {images.map((image, i) => (
        
        <IconImage
          src={image.image}
          zIndex={image.zIndex}
          left={image.left}
          onClick={() => imageClick(image.url)}
          data-tip="hello world"
          data-for={image.name}
        ></IconImage>
        
      ))}

      {images.map((image, i) => (
        
        <ReactTooltip id={image.name} place="top" type="light" effect="solid">
          <span>{image.name}. Click here!</span>
        </ReactTooltip>
        
      ))}

    </StyledContainer>
    
  );
};

const images = [
  {
    image: image1,
    zIndex: 1,
    left: "-5%",
    url: "https://www.michigandaily.com/section/bside/david-foster-wallace-beyond-windbreak",
    name: "Hi, I'm David Foster Wallace"
  },
  {
    image: image2,
    zIndex: 0.5,
    left: "-9%",
    url: "https://www.michigandaily.com/section/bside/eclectic-iconography-hyperpop",
    name: "Hi, I'm Grimes"
  },
  {
    image: image3,
    zIndex: 3,
    left: "-11%",
    url: "https://www.michigandaily.com/section/bside/girl-your-dreams-female-film-directors-icons",
    name: "Hi, I'm Andrea Arnold"
  },
  {
    image: image4,
    zIndex: 2,
    left: "-14%",
    url: "https://www.michigandaily.com/section/bside/bob-dylan-queer-icon",
    name: "Hi, I'm Bob Dylan"
  },
  {
    image: image17,
    zIndex: 4,
    left: "-17%",
    url: "https://www.michigandaily.com/section/bside/taylor-swift-icon-forever-and-always",
    name: "Hi, I'm Taylor Swift"
  },
  {
    image: image6,
    zIndex: 5,
    left: "-20%",
    url: "https://www.michigandaily.com/section/bside/celebrity-stans-michigan",
    name: "Hear students' thoughts on 'stan culture'"
  },
  {
    image: image7,
    zIndex: 7,
    left: "-22%",
    url: "https://www.michigandaily.com/section/bside/when-important-aren%E2%80%99t-perfect-george-balanchine",
    name: "Hi, I'm George Balanchine"
  },
  {
    image: image13,
    zIndex: 8,
    left: "-26%",
    url: "https://www.michigandaily.com/section/bside/love-letter-river-phoenix",
    name: "Hi, I'm River Phoenix"
  },
  {
    image: image9,
    zIndex: 6,
    left: "-30%",
    url: "https://www.michigandaily.com/section/bside/it%E2%80%99s-dolly%E2%80%99s-world-we%E2%80%99re-just-living-it",
    name: "Hi, I'm Dolly Parton"
  }
];

export default ImageContainer;
